import { translations } from '@spartacus/assets';
import { GonvarriProduct } from 'src/app/core/models/gonvarri-product.model';
import { Component, OnInit, Input, OnChanges, ViewChild } from '@angular/core';
import { TranslationService } from '@spartacus/core';
import { take } from 'rxjs/operators';
import { isAsturias, isPortugal, isValencia   } from 'src/app/utils/check-environment';
import {
  ProductGridItemComponent,
  ProductListItemContext,
  ProductListItemContextSource,
} from '@spartacus/storefront';
import { MAX_KG, MIN_KG } from 'src/app/utils/weight-utils';
import { GonvarriChapaQuantityComponent } from '../gonvarri-chapa-quantity/gonvarri-chapa-quantity.component';

@Component({
    selector: 'app-gonvarri-product-grid-item',
    templateUrl: './gonvarri-product-grid-item.component.html',
    styleUrl: './gonvarri-product-grid-item.component.scss',
    providers: [
        ProductListItemContextSource,
        { provide: ProductListItemContext, useExisting: ProductListItemContextSource }
    ],
    standalone: false
})
export class GonvarriProductGridItemComponent extends ProductGridItemComponent implements OnInit, OnChanges {

  @ViewChild('chapaQuantityComponent') chapaQuantityComponent!: GonvarriChapaQuantityComponent;

  @Input() GonvarriProduct!: GonvarriProduct;
  @Input() minHeight: boolean = false;

  lengthValue: number = 0;
  allowEditLength: boolean = false;
  allowEditWeight: boolean = true;
  weight: number = 1000;
  quantity: number = 1;
  weightError: string = '';
  isWeightValid: boolean = true;
  isAsturias: boolean = false;
  hasStock: boolean = false;
  isPurchaseBySheet: boolean = false;
  numberOfSheets: number = 1;
  disableAddToCart: boolean = false;

  constructor(
    protected override productListItemContextSource: ProductListItemContextSource,
    protected translation: TranslationService
  ) {
    super(productListItemContextSource);
  }

  ngOnInit(): void {
    this.isAsturias = isAsturias();
    this.validateStock();
    this.checkLength();
    this.checkWeight();
    this.onPurchasedBySheet();
  }

  ngAfterViewChecked(): void {
    this.onPurchasedBySheet();
  }

  checkLength(): void {
    if (this.product.isCustomLength === true) {
      this.allowEditLength = true;
      const prodLength = Number(this.product.standardLength) || 0;
      this.lengthValue = prodLength < 350 ? 350 : prodLength;
    } else {
      this.allowEditLength = false;
      this.lengthValue = this.product.standardLength || 0;
    }
  }

  checkWeight(): void {
    if(this.product.packageWeight === 0 ){
      this.weight = this.getWeightLimits().min;
    }
    else{
      this.allowEditWeight = false;
      this.weight = this.product.packageWeight;
    }
  }

  onLengthBlur(): void {
    if (this.lengthValue < 350) {
      this.lengthValue = 350;
    } else if (this.lengthValue > 12000) {
      this.lengthValue = 12000;
    }
  }

  private onPurchasedBySheet(): void {
    if (this.isPurchasedBySheet()){
      this.weight = this.computedPackageWeight;
      this.validateWeight(this.weight);
    }
  }

  updateNumberOfSheets(values: number[]): void {
    this.weight = values[0];
    this.numberOfSheets = values[1];
    this.validateWeight(this.weight);
  }

  get computedPackageWeight(): number {
    if (this.chapaQuantityComponent) {
      return Math.ceil(this.chapaQuantityComponent.numberOfSheets * this.chapaQuantityComponent.KG_EACH);
    }
    return this.weight;
  }

  validateWeight(newPackageWeight: number): void {
    this.weight = newPackageWeight;
    const { min, max } = this.getWeightLimits();

    if (this.weight < min) {
      this.translation
        .translate('productGrid.error.minimumWeight', { minWeight: min })
        .pipe(take(1))
        .subscribe((translatedMsg: string) => {
          this.weightError = translatedMsg;
        });
      this.isWeightValid = false;
    } else if (this.weight > max) {
      this.translation
        .translate('productGrid.error.maximumWeight', { maxWeight: max })
        .pipe(take(1))
        .subscribe((translatedMsg: string) => {
          this.weightError = translatedMsg;
        });
      this.isWeightValid = false;
    } else {
      this.weightError = "";
      this.isWeightValid = true;
    }
  }

  getWeightLimits(): { min: number; max: number } {
    return { min: MIN_KG, max: MAX_KG };
  }

  isPurchasedBySheet(): boolean {
    return !!this.product.isPurchaseBySheet;
  }

  updateIsDisabled(isDisabled: boolean): void {
    this.isWeightValid = !isDisabled;
  }

  private validateStock(): void {
    const stockLevel = this.product?.stock?.stockLevel ?? 0;

    this.hasStock = stockLevel > 0 || this.product?.stock?.stockLevelStatus === 'inStock';
  }

  validateQuantity(newQuantity: number): void {
    this.quantity = newQuantity;
  }
}
